// The columns of the companies' table between « Entreprise », which always
// stays first, and the commercial, always last (FIXED_LAST), in their default
// order (`label`: their key in the locales). A tab shows those it has
// (TAB_COLUMNS), in the order chosen in « Personnaliser les colonnes »
// (ModalCustomizeVivierColumns), kept in the browser.
export const COMPANY_COLUMNS = [
  { key: 'department', label: 'columnDepartment' },
  { key: 'category', label: 'columnCategory' },
  { key: 'group', label: 'columnGroup' },
  { key: 'action', label: 'columnAction' },
  { key: 'created', label: 'columnCreated' },
  { key: 'recruiter', label: 'columnRecruiter' },
  { key: 'reason', label: 'columnReason' },
  { key: 'relaunch', label: 'columnRelaunch' },
  { key: 'lostOn', label: 'columnLostOn' },
];
export const FIXED_LAST = { key: 'commercial', label: 'columnCommercial' };

export const TAB_COLUMNS = {
  prospects: ['department', 'category', 'group', 'action', 'created'],
  new: ['department', 'category', 'group', 'action'],
  old: ['department', 'category', 'group', 'action', 'recruiter'],
  lost: ['department', 'category', 'reason', 'relaunch', 'lostOn'],
};

export const COMPANY_COLUMNS_DEFAULT = COMPANY_COLUMNS.map((column) => column.key);
export const COMPANY_COLUMNS_KEY = 'companies_admin_columns';
export const COMPANY_COLUMNS_UPDATED = 'companies_columns_updated';

// The cells after « Entreprise » on a tab: those chosen it has, then the commercial.
export const columnsOfTab = (chosen, tab) => [
  ...chosen.filter((key) => TAB_COLUMNS[tab].includes(key)),
  FIXED_LAST.key,
];

// The columns kept from the browser, or all of them.
export const storedCompanyColumns = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(COMPANY_COLUMNS_KEY));
    return Array.isArray(stored) ? stored.filter((key) => COMPANY_COLUMNS_DEFAULT.includes(key)) : COMPANY_COLUMNS_DEFAULT;
  } catch {
    return COMPANY_COLUMNS_DEFAULT;
  }
};
